import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as L from "leaflet";
import { Observable, Subject, throwError } from 'rxjs';
import { ConfigurationService } from './configuration.service';
import { ProfileService } from './profile.service';


export interface PreferredDriversPut{
  adId: string;
  preferredDrivers: string;
  type: string;
}

@Injectable({
  providedIn: 'root'
})
export class ManageVansService {
  public zoomLocation$: Subject<L.LatLng> = new Subject();
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpClient,
    private profileService: ProfileService
  ) { }

  unassignVan(vanName: string): Observable<HttpResponse<any>>{
    const config = this.configurationService.configuration$.getValue();
    if (!config) {
      return throwError(new Error('Configuration not loaded'));
    }
    const url = config.HostApi.concat('/asset/unassign/').concat(vanName);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put<HttpResponse<any>>(url, {}, { headers, observe: 'response' });
  }

  updateZoomLocation(data: L.LatLng): void {
    this.zoomLocation$.next(data);
  }

  getZoomLocation(): Observable<L.LatLng> {
    return this.zoomLocation$.asObservable();
  }

  savePrefDriverList(preferredDriversList: Array<string>): Observable<HttpResponse<any>>{
    const config = this.configurationService.configuration$.getValue();
    if (!config) {
      return throwError(new Error('Configuration not loaded'));
    }
    const dedupList = [...new Set(preferredDriversList)];
    const stringList = dedupList.join(":");
    const payload:PreferredDriversPut = {
      adId: this.profileService.profileObs$.getValue().adId,
      preferredDrivers: stringList,
      type: "personUpdate"
    }
    const url = config.HostApi.concat('/asset');
    const headers = new HttpHeaders().set("Content-type", "application/json; charset=utf-8");
    return this.http.put<HttpResponse<any>>(url, JSON.stringify(payload), { "headers":headers, observe: 'response' });
  }
}
